import './OpSearchInput.scss'

import React from 'react'

export const OpSearchInput = ({ onChange, placeholder, value }) => {
    const changeHandler = evt => onChange(evt.target.value)
    const onClear = () => onChange('')

    return (
        <div className="OpSearchInput">
            <div className="SearchInput glyphicon glyphicon-search">
                <input type="search" placeholder={placeholder} onChange={changeHandler} value={value} />
            </div>
            <button className="SearchClear" onClick={onClear}>&times;</button>
        </div>
    )
}